import React, {useEffect, useRef} from 'react';
import './App.css';

function App() {
  const canvasRef = useRef(null);
  const scrollRef = useRef<HTMLDivElement>(null!);


  useEffect(() => {
    let canvas: any

    canvas = canvasRef.current;
    const ctx = canvas.getContext('2d', {colorSpace: "display-p3"});
    var width = canvas.width = window.innerWidth * 1.2;
    var height = canvas.height = window.innerHeight * 3;
    var area = width * height;
    var starsPerArea = 0.00015;
    // TODO: get a equal amount for area
    var numStars = area * starsPerArea;
    var stars: { x: number; y: number; radius: number; color: string; }[] = [];


    for (let i = 0; i < numStars; i++) {
      stars.push({
        x: Math.random() * width,
        y: Math.random() * height,
        radius: Math.random() * 1.5 + 1,
        color: 'color(display-p3 1 1 1)'
      });
    }


    function drawStar(star: { x: any; y: any; radius: any; color: any; }) {
      ctx.beginPath();
      ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
      ctx.fillStyle = star.color;
      ctx.fill();
    }


    function drawStars() {
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = 'black';
      ctx.fillRect(0, 0, width, height);
      stars.forEach(star => {
        drawStar(star);
      });
    }


    //drawStars();
    var targetOffset = 0;
    var currentOffset = 0;
    var lastScrollY = scrollRef.current.scrollTop;


    const handelTick = () => {
      var scrollY = scrollRef.current.scrollTop;

      targetOffset += (lastScrollY - scrollY) * 0.25;

      lastScrollY = scrollY;

      // lerping with a max value
      var lerp = (targetOffset - currentOffset) * 0.02;
      lerp = Math.min(lerp, 40);


      currentOffset += lerp;

      stars.forEach(star => {
        // todo optimize
        star.x -= lerp;
        star.y -= lerp;
        if (star.x < 0) {
          star.x = width + star.x;
        }
        if (star.y < 0) {
          star.y = height + star.y;
        }

        if (star.x > width) {
          star.x = star.x - width;
        }

        if (star.y > height) {
          star.y = star.y - height;
        }
      });

      drawStars();

      window.requestAnimationFrame(handelTick);
    }
    const handleResize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
      area = width * height;

      starsPerArea = 0.0001;
      // TODO: get a equal amount for area
      numStars = area * starsPerArea;

      stars = [];
      for (let i = 0; i < numStars; i++) {
        stars.push({
          x: Math.random() * width,
          y: Math.random() * height,
          radius: Math.random() * 1.5 + 1,
          color: 'white'
        });
      }
      //drawStars();
    }

    window.addEventListener('resize', handleResize)
    window.requestAnimationFrame(handelTick);
    return () => {
      window.removeEventListener("resize", handleResize);

    }


  }, []);


  return (
    <div className="App">
      <div ref={scrollRef} className="hide-scrollbar" style={{height: '100vh', overflowY: 'scroll'}}>
        <header className="App-header">
          <canvas ref={canvasRef} className="bg-stars"></canvas>

          {/*<div className={"full-container"}>*/}
          {/*  <h1 className={"rounded-text"}>NAME PLACEHOLDER</h1>*/}
          {/*</div>*/}

          <div style={{height: '30000vh', width: '100vw'}}>

          </div>

        </header>
      </div>
    </div>
  );
}

export default App;
